import React from 'react';
import Select from 'react-select';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import Permissions from '../../../configurations/permissions';
import ArbiterApi from '../../../api/ArbiterApi';
import DisputeTimelinesTable from './disputeTimelinesTable';
import DisputeTimelinesModal from './disputeTimelinesModal';


class DisputeTimelinesPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            disputeTimelines: [],
            selectedDisputeTimeline: null,
            disputeRegions: [],
            disputeRegion: null,
            disputeCategories: [],
            disputeCategory: null,
            disputeStatuses: [],
            disputeStatus: null,
            totalCount: 0,
            loading: false,
            pages: 0,
            openModalFlag: false,
            createFlag: false,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onNewButtonClick = this.onNewButtonClick.bind(this);
        this.handleRegionFilterChange = this.handleRegionFilterChange.bind(this);
        this.handleCategoryFilterChange = this.handleCategoryFilterChange.bind(this);
       
    }

    componentDidMount() {

        //Get Dispute Regions
        ArbiterApi.getDisputeRegions()
            .then(response => {

                let disputeRegions = response.data.content.map(obj => {

                    obj.label = obj.name;
                    obj.value = obj.name;
                    return obj;
                });

                this.setState({ disputeRegions });
            })
            .catch(error => {
                Toaster.error(`${error.status} - ${Messages.ERROR_DISPUTE_REGION} - ${error.data ? error.data.description : error.statusText}`);
                console.log(error);
            })

        //Get Dispute Categories
        ArbiterApi.getDisputeCategories()
            .then(response => {

                let disputeCategories = response.data.map(obj => {

                    obj.label = obj.category;
                    obj.value = obj.category;
                    obj.statuses = obj.statuses.map(status => {
                        return {
                            label: status,
                            value: status,
                        }
                    })
                    return obj;
                });

                this.setState({ disputeCategories });
            })
            .catch(error => {
                Toaster.error(`${error.status} - ${Messages.ERROR_DISPUTE_CATEGORIES} - ${error.data ? error.data.description : error.statusText}`);
                console.log(error);
            })


        //Load data on mount
        this.reloadTimelines();
    }

    onNewButtonClick(evt) {
        this.setState({ openModalFlag: true, createFlag: true });
    }
    handleRegionFilterChange(evt) {
        this.setState({ disputeRegion: evt }, () => this.reloadTimelines());
    }

    handleCategoryFilterChange(evt) {
        this.setState({ 
            disputeCategory : evt , 
            disputeStatuses : evt ? evt.statuses : [], 
            disputeStatus: null
         }, 
         () => this.reloadTimelines());
    }

    render() {

        return (

            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Dispute Timelines" />
                <Divider />
                <div className="mini-filter">
                    <button onClick={this.onNewButtonClick} className="btn btn-primary right" >+ New Dispute Timeline</button>
                    <div className="filter-select">
                        <Select
                            placeholder="Dispute Regions"
                            onChange={this.handleRegionFilterChange}
                            options={this.state.disputeRegions}
                            value={this.state.disputeRegion}
                        />
                    </div>
                    <div className="filter-select">
                        <Select
                            placeholder="Dispute Categories"
                            onChange={this.handleCategoryFilterChange}
                            options={this.state.disputeCategories}
                            value={this.state.disputeCategory}
                        />
                    </div>

                </div>
                <DisputeTimelinesTable
                    onRowClick={this.onRowClick}
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    disputeTimelines={this.state.disputeTimelines}
                />
                {this.state.openModalFlag &&
                    <DisputeTimelinesModal
                        isNew={this.state.createFlag}
                        isOpen={this.state.openModalFlag}
                        onRequestClose={this.handleCloseModal}
                        disputeTimeline={this.state.selectedDisputeTimeline}
                    />
                }
            </div>
        )
    }


    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadTimelines(params);
        }

    }

    loadTimelines(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);

        let disputeRegion = this.state.disputeRegion;

        if (disputeRegion && disputeRegion.value) {
            params.disputeRegion = disputeRegion.value;
        }

        let disputeCategory = this.state.disputeCategory;

        if (disputeCategory && disputeCategory.value) {
            params.disputeCategory = disputeCategory.value;
        }

        let disputeStatus = this.state.disputeStatus;

        if (disputeStatus && disputeStatus.value) {
            params.disputeStatus = disputeStatus.value;
        }
        ArbiterApi.getDisputeTimelines(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Dispute Timelines")
                this.setState({ disputeTimelines: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTE_TIMELINES} - ${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ loading: false });
            });
    }

    onRowClick(index) {
        this.setState({ selectedDisputeTimeline: this.state.disputeTimelines[index], openModalFlag: true, createFlag: false });
    }
    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedDisputeTimeline: null, openModalFlag: false, createFlag: false });
        if (reloadDataFlag) {
            this.reloadTimelines();
        }
    }

    reloadTimelines() {
        this.setState({ disputeTimelines: [] });
        this.loadTimelines({ pageSize: this.state.pageSize });
    }

}


export default connect(Util.defaultMapStateToProps)(Permissioned(DisputeTimelinesPage, [Permissions.VIEW_DISPUTE_TIMELINE]));


// WEBPACK FOOTER //
// ./src/components/admin/disputeTimelines/disputeTimelinesPage.js